/**
 * Edit-warehouse route — mounts `<WarehouseComposerPage loadWarehouseId={...} />`.
 *
 * @see apps/web/src/features/inventory/warehouses/warehouse-composer-page.tsx
 */
import { createFileRoute } from "@tanstack/react-router";
import { WarehouseComposerPage } from "../../../../features/inventory/warehouses/index.ts";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";

export const Route = createFileRoute("/(workspace)/inventory/warehouses/$warehouseId/edit")({
  component: EditWarehouseRoute,
});

function EditWarehouseRoute() {
  const { warehouseId } = Route.useParams();
  return (
    <WorkspaceShell
      breadcrumbs={[
        { label: "Inventory", to: "/" },
        { label: "Warehouses", to: "/inventory/warehouses" },
        { label: "Edit warehouse" },
      ]}
      viewportClassName="p-0"
      contentClassName="max-w-none h-full"
      disableViewportScroll
    >
      <WarehouseComposerPage loadWarehouseId={warehouseId} />
    </WorkspaceShell>
  );
}
